/**
 * @generated SignedSource<<c4b88c2b5c967baedf4628aff31ca1e6>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type TVDashboardPickerPopoverDashboards$data = ReadonlyArray<{
  readonly id: string;
  readonly " $fragmentSpreads": FragmentRefs<"TVDashboardPickerPopoverItem_dashboard">;
  readonly " $fragmentType": "TVDashboardPickerPopoverDashboards";
}>;
export type TVDashboardPickerPopoverDashboards$key = ReadonlyArray<{
  readonly " $data"?: TVDashboardPickerPopoverDashboards$data;
  readonly " $fragmentSpreads": FragmentRefs<"TVDashboardPickerPopoverDashboards">;
}>;

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": {
    "plural": true
  },
  "name": "TVDashboardPickerPopoverDashboards",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "TVDashboardPickerPopoverItem_dashboard"
    }
  ],
  "type": "Dashboard",
  "abstractKey": null
};

(node as any).hash = "b499571f5a8189507fd79e74194cee82";

export default node;
